<template>
    <div class="container-fluid">
        <Uploadpage :PersianName="'آمــوزش'" :EnglishName="'Education'"></Uploadpage>
    </div>
</template>

<script>
import Uploadpage from './Component/Uploadpage.vue';
export default{
    components: { Uploadpage }
}
</script>